let html = `<div class="season-episode selector layer--visible">
    <div class="season-episode__img">
        <img alt="">
        <div class="season-episode__loader"></div>
    </div>
    <div class="season-episode__body">
        <div class="season-episode__head">
            <div class="season-episode__title">{title}</div>
            <div class="season-episode__time">{time}</div>
        </div>

        <div class="season-episode__timeline"></div>

        <div class="season-episode__footer">
            <div class="season-episode__info">{info}</div>
            <div class="season-episode__quality">{quality}</div>
        </div>
    </div>
</div>`

export default html